import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ProductDataFilter from "../../../components/product-data-filter/product-data-filter";
import GenericDataChart from "../../../GenericPageElements/GenericDataChart";
import GenericPageContainer from "../../../GenericPageElements/GenericPageContainer";
import GenericProductFilterContainer from "../../../GenericPageElements/GenericProductFilterContainer";
import endpoints from "../../../helpers/endpoints";
import hasPermission from '../../../helpers/permissions';
import request from "../../../helpers/request";
import S3Modal from "../../../components/s3Modal/S3Modal";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";
import { view } from "@risingstack/react-easy-state";
import { Link } from "react-router-dom";
import BulkBuy from '../../../components/cot-alert-bulk-buy/bulkBuy';
import BulkAllocate from '../../../components/cot-alert-bulk-allocate/bulkAllocate';
import { CustomizedAxisTickMultiLine } from "../../../components/GraphComponents";
import './UPRNChanges.scss';

export default view(function UPRNChangesSummary() {
  const [filters, setFilters] = useState({});
  const [selectedGroupBy, setSelectectGroupBy] = useState("UPRN_Change_Type");
  const [data, setData] = useState(null);
  const [dates, setDates] = useState([]);
  const [date, setDate] = useState(null);
  const [S3Model, setS3Model] = useState(null);
  const [bulkModel, setBulkModel] = useState('')

  useEffect(() => {
    console.log(S3Model)
  }, [S3Model])
  
  const applyFilter = (column, value) => {
    setFilters((current) => {
      return {
        ...current,
        [column]: value,
      };
    });
  };

  useEffect(() => {
    request(true)
      .get(endpoints.UPRN_CHANGES_DATES)
      .then((e) => {
        setDates(e.data.dates);
        if (e.data.dates.length > 0) setDate("All_Refreshes");
      });
  }, []);

  useEffect(() => {
    // if (!date) return;
    request(true)
      .get(endpoints.UPRN_CHANGES_DATA, {
        doesCancel: true,
        params: {
          date: date,
          filter: filters,
          group: selectedGroupBy,
        },
      })
      .then((e) => {
        setData(e.data);
      });
  }, [filters, selectedGroupBy, date]);

  return [
    <GenericPageContainer
      title="UPRN Changes - Summary"
      titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
      containerWidth={'92vw'}
      titleRight={
        <div>
          {hasPermission('UPRN_CHANGES', 'DOWNLOAD') ? (
              <button className="navigate" onClick={() => setS3Model("download")}>
                  Download Return File
              </button>
          ) : null}
          {hasPermission('UPRN_CHANGES', 'UPLOAD') ? (
            <button className="navigate" onClick={() => setS3Model("upload_spids")}>
              Upload SPIDs
            </button>
          ) : null}
          { (hasPermission('UPRN_CHANGES', 'WORKFLOW')) ?
            <Link className="navigate" to="/portal/uprn-changes/premises-workflow">
              Premises Workflow
            </Link>
          : null }
        </div>
      }
    >
      <div style={{maxWidth: '20vw', marginBottom: 15}}>
      <GenericDataRow title={"File Date"} contentColour={"white"}>
        <select
          onChange={(_) => setDate(_.target.value)}
          value={date}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            backgroundColor: "white",
            paddingLeft: "10px",
          }}
        >
          <option key={"All_Refreshes"} value={"All_Refreshes"}>All Refreshes</option>
          {dates.map((item) => {
            return (
              <option key={item.raw} value={item.raw}>
                {item.pretty}
              </option>
            );
          })}
        </select>
      </GenericDataRow>
      </div>
      <div className='UPRNC'>
        <GenericDataChart
          dataReady={!!data}
          data={data}
          selectedGroupBy={selectedGroupBy}
          setSelectectGroupBy={setSelectectGroupBy}
          groupingsEndpoint={endpoints.UPRN_CHANGES_GROUPINGS}
          sizes={{chart: 600, chartContainer: 625, chartXAxisFontSize: 12, wrapperStyle: { paddingTop: '40px' }}}
          xAxisProps={{interval: 0}}
          customBarTick={CustomizedAxisTickMultiLine}
          overrideTableHeader={"Summary"}
          displayModeInitial="table"
          tableClasses="uprn-changes-summary-table"
        />
        <GenericProductFilterContainer clearFilters={() => setFilters({})}>
          <ProductDataFilter
            filterState={filters}
            applyFilter={applyFilter}
            dataFilterEndpoint={endpoints.UPRN_CHANGES_FILTERS}
          />
          <div className='grid grid-columns-2 grid-gap-5 mta'>
              { (hasPermission('UPRN_CHANGES', 'ALLOCATE')) ?
                <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('allocate_premises')}>
                    Allocate Premises
                </button>
              : '' }
              { (hasPermission('UPRN_CHANGES', 'UNALLOCATE')) ?
                <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('unallocate_premises')}>
                    Unallocate Premises
                </button>
              : '' }
              { (hasPermission('UPRN_CHANGES', 'BULK-BUY')) ?
                <button style={{  gridColumn: 'span 2' }} className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('purchase')}>
                  Create Download File
                </button>
              : '' }
          </div>
        </GenericProductFilterContainer>
      </div>
    </GenericPageContainer>,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      showModal={S3Model === "download"}
      listingUrl={endpoints.UPRN_CHANGES_FILES}
      uploadUrl={endpoints.UPRN_CHANGES_FILES}
    />,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      showModal={S3Model === "upload_spids"}
      titleOverride={"Upload Core SPID list"}
      listingUrl={endpoints.UPRN_CHANGES_FILES}
      uploadUrl={endpoints.UPRN_CHANGES_UPLOAD_SPIDS}
      successMessageOverride={"Your file is being processed. You will receive an email once complete."}
    />,
    <BulkBuy 
      SentenceFirst={({count}) => <>The selected data set includes {count} SPIDs to be downloaded. Press the 'Create File' button to create the download file and you will receive an email notification once this is available. Alternatively press the 'Cancel' button to go back to the summary screen.</>}
      SentenceSecond={() => <></>}
      purchaseLabel="Download Limit:"
      buyButtonText="Create File"
      completeOnFirstStep={true} 
      workflowUsersEndpoint={endpoints.UPRN_CHANGES_WF_USERS} 
      bulkEndpoint={endpoints.UPRN_CHANGES_BULK_BASE} 
      modalIsOpen={bulkModel === 'purchase'} 
      closeModal={() => setBulkModel('')} 
      filters={filters} 
      date={date} 
    />,
    <BulkAllocate 
    workflowUsersEndpoint={endpoints.UPRN_CHANGES_WF_USERS} 
    bulkEndpoint={endpoints.UPRN_CHANGES_BULK_SPIDS} 
    unallocateEndpoint={endpoints.UPRN_CHANGES_UNALLOCATE_SPIDS} 
    modalIsOpen={bulkModel === 'allocate_premises' || bulkModel === "unallocate_premises"} 
    mode={bulkModel === "unallocate_premises" ? "unallocate" : "allocate_premises"}
    closeModal={() => setBulkModel('')} 
    filters={filters} 
    date={date} />,
  ];
})
